import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngDataTableComponent } from './kng-data-table.component';
import { KngDataTableService } from './kng-data-table.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [
		KngDataTableComponent
	],
	imports: [ CommonModule, MatCheckboxModule, FormsModule, NgxPaginationModule, MatTooltipModule ],
	exports: [
		KngDataTableComponent
	],
	providers: [
		KngDataTableService
	]
})
export class KngDataTableModule {}
